<div class="terms-page">
  <div class="terms-card">
    <header class="terms-header">
      <h1>Politika privatnosti</h1>
      <p class="terms-subtitle">SPD RADNIČKI DOO KRAGUJEVAC</p>
      <p class="terms-updated">Primenjuje se počev od: {{ lastUpdated }}</p>
    </header>

    <section class="terms-section">
      <h2>I Opšti uslovi prikupljanja, korišćenja i obrade ličnih podataka Kupaca ulaznica za bazene SPD Radnički</h2>
      <p>
        Privatnost i poverenje Kupaca su veoma važni za Trgovca kao Rukovaoca Vašim ličnim
        podacima. Ovo se odražava na način na koji mi kao Trgovac prikupljamo i obrađujemo
        podatke Kupaca. Kupac se savetuje da u potpunosti pročita odredbe ove Politike
        privatnosti kako bi doneo odluku koje podatke želi da podeli sa Trgovcem. Trgovac je
        Rukovalac ličnim podacima.
      </p>
      <p>
        Rukovalac podatke o ličnosti obrađuje u skladu sa Zakonom o zaštiti podataka o ličnosti
        („Sl. glasnik RS”, br. 87/2018) i drugim važećim propisima Republike Srbije.
      </p>
    </section>

    <section class="terms-section">
      <h2>II Definicije</h2>
      <p>
        <strong>Trgovac</strong> – SPD RADNIČKI DOO KRAGUJEVAC, privredno društvo osnovano i
        registrovano u skladu sa propisima Republike Srbije sa registrovanim sedištem na adresi
        Ulica Grada Sirena br. 15, matični broj: 07150717, PIB: 101315191, čija je pretežna
        registrovana delatnost 9312 - delatnost sportskih klubova, kontakt telefon: 034 331 958,
        mejl: <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.
      </p>
      <p>
        <strong>Kupac</strong> – fizičko ili pravno lice koje posredstvom Aplikacije SPD Radnički
        putem interneta od Trgovca kupuje Ulaznice za otvorene i zatvorene bazene Trgovca koji se
        nalaze na adresi Dragutina Kojića 2, Kragujevac (u daljem tekstu: Bazeni).
      </p>
      <p>
        <strong>Aplikacija</strong> – Aplikacija SPD Radnički putem koje se vrši internet
        kupovina Ulaznica od strane Kupaca.
      </p>
      <p>
        <strong>Ulaznice</strong> – ulaznice za korišćenje Bazena Trgovca, čiji spisak kao i cene
        su dati u Aplikaciji.
      </p>
    </section>

    <section class="terms-section">
      <h2>III Svrha prikupljanja podataka i pravni osnov obrade</h2>
      <p>
        Prilikom kupovine Ulaznica posredstvom Aplikacije Trgovac će prikupljati od Kupaca
        određene lične podatke, a u cilju izvršavanja obaveza koje iz takvog ugovora proističu.
        Sve aktivnosti Trgovca u pogledu prikupljanja i obrade ličnih podataka Kupca biće
        obavljane u skladu sa Zakonom o zaštiti podatka o ličnosti RS (u daljem tekstu: Zakon) i
        drugim važećim propisima.
      </p>
      <p>Podaci o ličnosti obrađuju se:</p>
      <ul>
        <li>
          radi preduzimanja radnji na zahtev Kupca pre zaključenja ugovora radi korišćenja
          Aplikacije i izvršenja ugovora o kupovini ulaznica;
        </li>
        <li>radi ispunjenja zakonskih obaveza Trgovca;</li>
        <li>
          kada je obrada neophodna radi ostvarivanja legitimnih interesa Trgovca, osim kada nad
          tim interesima pretežu prava i slobode Kupca;
        </li>
        <li>
          radi slanja marketinških obaveštenja isključivo na osnovu prethodno izričite date
          dobrovoljne saglasnosti Kupca.
        </li>
      </ul>
      <p>
        Davanje saglasnosti za marketing nije uslov za kupovinu ulaznica i Kupac može opozvati
        saglasnost u svakom trenutku, bez uticaja na zakonitost prethodno izvršene obrade.
      </p>
      <p>
        Svaki lični podatak koji prikupimo od Vas biće sačuvan na sigurnom CLOUD-u koji se nalazi
        na infrastrukturi DRŽAVNOG DATA CENTRA – DATA CLOUD TECHNOLOGY DOO KRAGUJEVAC koji se
        nalazi u Republici Srbiji.
      </p>
    </section>

    <section class="terms-section">
      <h2>IV Rok čuvanja podataka</h2>
      <p>
        Podaci o ličnosti čuvaju se samo onoliko dugo koliko je potrebno za ostvarenje svrhe zbog
        koje su prikupljeni, odnosno u rokovima propisanim važećim propisima Republike Srbije.
        Podaci koji se obrađuju na osnovu saglasnosti čuvaju se do njenog opoziva, osim ako
        postoji drugi zakonski osnov za dalje čuvanje.
      </p>
    </section>

    <section class="terms-section">
      <h2>V Prava lica na koje se podaci odnose</h2>
      <p>
        Trgovac kao rukovalac Vaših ličnih podataka podleže odgovornosti ukoliko bude vršio
        obradu Vaših ličnih podataka na način koji je u suprotnosti sa pozitivnim propisima
        Republike Srbije.
      </p>
      <p>Imate pravo da:</p>
      <ul>
        <li>u skladu sa članom 26. Zakona od rukovaoca zahtevate pristup podacima;</li>
        <li>
          pravo na ispravku ili brisanje Vaših podataka o ličnosti u skladu sa čl. 29. i 30.
          Zakona;
        </li>
        <li>pravo na ograničenje obrade u skladu sa članom 31. Zakona;</li>
        <li>prava na prenosivost podataka u skladu sa članom 36. Zakona;</li>
        <li>kao i pravo na prigovor u skladu sa članom 37. Zakona.</li>
      </ul>
      <p>
        Takođe, imate pravo da u skladu sa članom 82. Zakona podnesete pritužbu Povereniku za
        informacije od javnog značaja i zaštitu podataka o ličnosti, ako smatrate da je obrada
        podataka o Vašoj ličnosti izvršena suprotno odredbama Zakona.
      </p>
    </section>

    <section class="terms-section">
      <h2>VI Pravila o zaštiti privatnosti</h2>
      <p>
        Trgovac poštuje Vašu privatnost i obavezuje se da zaštiti privatnost i poverljivost
        ličnih podataka osoba koje se registruju ili na drugi način povežu sa Trgovcem.
      </p>

      <h3>a) Vrste ličnih podataka koje prikupljamo i način njihove upotrebe</h3>
      <p>
        Kako bismo Vam omogućili korišćenje Aplikacije za kupovinu Ulaznica, uz Vašu izričitu
        saglasnost koju ovim putem dajete prikupljamo sledeće podatke o Vama: Vaše ime, prezime,
        adresu e-pošte.
      </p>
      <p>
        Vaše pružanje podataka se zasniva na potpuno dobrovoljnoj osnovi, odnosno Vi slobodno
        odlučujete da li ćete nam dostaviti Vaše podatke i koji će to podaci biti. U slučaju da ne
        želite da nam dostavite neki od podataka koji je neophodan za pružanje usluga, odnosno
        zaključenje Ugovora (npr. e-mail adresu), zadržavamo pravo da odbijemo da Vam pružimo
        usluge.
      </p>
      <p>
        U svakom trenutku možete tražiti da Vaše podatke ne koristimo za sprovođenje marketinških
        aktivnosti, odnosno radi analize naših prodajnih aktivnosti i to neće uticati na opstanak
        našeg ugovornog odnosa.
      </p>
      <p>
        Podaci kojima se možete identifikovati neće se koristiti ni za kakve druge namene osim za
        one za koje ste dali izričitu saglasnost.
      </p>

      <h3>b) Treće strane</h3>
      <p>
        Trgovac neće prodavati, distribuirati, izdavati ili na bilo koji drugi način činiti
        dostupnim Vaše lične podatke bilo kome bez Vaše izričite dozvole, osim (i) ako ste to
        dozvolili u skladu s ovim Opštim uslovima kako bi dobili pristup željenim uslugama i (ii)
        ukoliko smo na to obavezani zakonskim propisima ili odlukama nadležnih organa.
      </p>
      <p>
        Radi održavanja Aplikacije u ograničenom obimu vašim podacima može pristupiti provajder
        usluga održavanja Aplikacije.
      </p>
      <p>
        S vremena na vreme možda ćemo angažovati druga pravna i fizička lica za obavljanje
        određenih funkcija u naše ime (npr. angažovanje spoljnih saradnika). Oni će u tom slučaju
        imati pristup Vašim ličnim podacima u ograničenom obimu i isključivo kako bi mogli
        obavljati poslove za koje smo ih angažovali i koji su u skladu sa Vašim pristankom za
        obradu Vaših ličnih podataka, no ne smeju ih koristiti ni u koju drugu svrhu.
      </p>
      <p>
        U gore navedenim slučajevima, s pružaocima usluga uvek zaključujemo ugovore o čuvanju
        tajnosti podataka kako bismo osigurali da Vaši podaci ostaju sigurni i da se s njima
        ispravno postupa. Vaši lični podaci neće se iznositi van Republike Srbije.
      </p>

      <h3>c) Ažuriranje Vaših ličnih podataka</h3>
      <p>
        Trgovcu kao Rukovaocu će biti potrebna Vaša pomoć kako bi se osiguralo da su Vaši lični
        podaci koje ste nam dostavili ispravni i ažurni. Ukoliko želite izmeniti ili ažurirati
        Vaše lične podatke ili ukoliko želite da izbrišemo Vaše podatke iz naše baze, zahtev za
        navedeno možete učiniti pisanim putem na adresu
        <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.
      </p>
      <p>
        Na Vaš zahtev, mi ćemo iz naše baze podataka ukloniti sve Vaše lične podatke koje ste nam
        dostavili i smatraćemo da ste time jednostrano raskinuli zaključeni Ugovor sa nama, ali
        nećemo biti obavezni da vam vratimo do tada uplaćene iznose.
      </p>
      <p>
        Nakon što primimo Vaš zahtev za brisanjem ličnih podataka, nećemo više čuvati ni jedan
        Vaš lični podatak, osim ako je drugačije određeno propisima koji se primenjuju u Republici
        Srbiji. Vaše podatke ćemo čuvati dok sa nama budete bili u ugovornom odnosu, odnosno dok
        budete koristili naše usluge.
      </p>

      <h3>d) Bezbednost podataka</h3>
      <p>
        Trgovac primenjuje odgovarajuće tehničke, organizacione i kadrovske mere radi zaštite
        podataka od neovlašćenog pristupa, gubitka, izmene, uništenja ili drugog oblika nezakonite
        obrade, u skladu sa važećim propisima. Vaši lični podaci čuvaju se u zaštićenoj bazi
        podataka. Trgovac kao Rukovalac Vašim podacima će preduzeti sve mere predostrožnosti (do
        razumne granice) kako bi se osigurala sigurnost Vaših podataka. Iako ulažemo napore u
        zaštitu Vaših ličnih podataka, ne možemo Vam bezuslovno garantovati sigurnost podataka
        koje nam dostavljate, pa to činite na vlastiti rizik.
      </p>
    </section>

    <section class="terms-section">
      <h2>VII Način na koji nas možete kontaktirati</h2>
      <p>
        Ukoliko imate bilo kakva pitanja ili zahteve u vezi Vaših ličnih podataka koje ste nam
        učinili dostupnim možete nas kontaktirati na neki od sledećih načina:
      </p>
      <ul>
        <li>poštom na adresu sedišta Trgovca, Ulica Grada Sirena broj 15, Kragujevac;</li>
        <li>putem maila – <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.</li>
      </ul>
      <p>
        Na sve što nije definisano ovom Politikom privatnosti, primenjivaće se Zakon o zaštiti
        podataka o ličnosti Republike Srbije i drugi propisi važeći u Republici Srbiji.
      </p>
      <p>
        Ova Politika privatnosti društva SPD Radnički doo Kragujevac doneta je i objavljena na
        internet stranici
        <a href="https://www.spdradnickikragujevac.com/" target="_blank" rel="noopener">https://www.spdradnickikragujevac.com/</a>
        i primenjuje se počev od {{ lastUpdated }} godine.
      </p>
    </section>

    <footer class="terms-footer">
      <p>&copy; {{ lastUpdated.slice(6, 10) }} SPD Radnički doo Kragujevac. Sva prava zadržana.</p>
    </footer>
  </div>
</div>
